import React, { Component } from 'react';
// import ProfileSchema from '../../../schema/counsellor-profile';
// import Inputlayer from '../../../components/FormComponent/Input';
// import { filter, formData, dissableFormData } from '../../../schema/apppointment';
import Tableantd from '../../../../components/FormComponent/table/antd';
import { privilegeTableSchema } from './../../../../schema/privilege-table';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import Storage from '../../../../services/local-store';
import { Modal, Spin } from 'antd';

const $ = require('jquery');
const {homepage} = networkList;
class User_Details extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            'details': {},
            'rid': null,
            'thead': [],
            "showAdd": true,
            "showEdit": false,
            'tbody': [],
            'tableTitle': '',
            'addText': '',
            privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema['feilds'])),
            tableHeadDoctor:[],
            tbodyDoctor:[]
        }
    }
    editUser(data) {

        try {
            let { rid } = this.state
            let { slug } = this.props.match.params;
            switch (slug) {
                case 'view-user':
                    this
                        .props
                        .history
                        .push(`/settings/edit-user?rid=` + data['id']);
                    break
                case 'view-doctor':
                    this
                        .props
                        .history
                        .push(`/settings/edit-doctor?rid=` + data['id']);
                    break;
                default:
                    break;    

            }
        } catch (error) {
            console.log(error);
        }

    }

    componentDidMount() {
        window.scrollTo(0,0);
        let { id, slug } = this.props.match.params
        let { menuList } = this.props;
        const { privilegeTableSchema } = this.state;
        menuList.map((menu) => {
            if (slug !== undefined && slug !== null && slug !== '') {
                if (menu['route'] === id) {
                    menu['submenu'].map((smenu) => {
                        if (smenu['route'] === slug) {
                            if (smenu['permissions']['view']) {
                                this.setState((state) => ({
                                    "showAdd": JSON.parse(smenu['permissions']['add']),
                                    "showEdit": JSON.parse(smenu['permissions']['edit'])
                                }));
                            }else{

                            }
                        }
                    })
                }
            }
        })
        privilegeTableSchema[0]['visible'] = false
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const unid = params.get('unid');
        this.setState((state) => ({ 'rid': rid,'unid': unid, 'loadding': true ,privilegeTableSchema}), () => {
            this.loadPage();
        })
    }

    cancel() {
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'view-user':
                this
                    .props
                    .history
                    .push('/settings/users');
                break;
            case 'view-doctor':
                this
                    .props
                    .history
                    .push('/settings/doctors');
                break;
            default:
                break;    
        }
    }

    loadPage = () => {
        try {
            let { rid,unid ,privilegeTableSchema} = this.state
            let { slug } = this.props.match.params;
            const { getRolesList, getUserDetailsById, getDoctorIdDetails } = networkList;
            let tableHead = [];
            let tableHeadDoctor=[]
            switch (slug) {
                case 'view-user':
                    tableHead = [
                        {
                            "key": 'gender',
                            'text': 'Gender'
                        }, {
                            "key": 'phone_number',
                            'text': 'Phone'
                        }, {
                            "key": 'unitname',
                            'text': 'Unit'
                        }, {
                            "key": 'rolename',
                            'text': 'Role',
                        }, {
                            "key": 'userid',
                            'text': 'User ID'
                        } ,{
                            "key": 'nurse_station',
                            'text': 'Work Station'
                        }
                    ]
                    tableHeadDoctor = [
                        {
                            "key": 's_no',
                            'text': 's.no'
                        },{
                            "key": 'doctor_name',
                            'text': 'Doctor Name',
                        },{
                            "key": 'doctor_id',
                            'text': 'Doctor ID',
                        },
                         {
                            "key": 'fk_department_id',
                            'text': 'Department',
                        },
                        
                      ]
                    privilegeTableSchema[0]['visible'] = false;

                    privilegeTableSchema.map((data, secKey) => {
                        data['Specification']['table_body'].map((table_body, table_key) => {
                            table_body['feilds'].map((feilds, key) => {
                                if(key===0){
                                    if (feilds.name === "privilege_name") {
                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = null
                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = null
                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['disable']=true;
                                    }
                                    if (feilds.name === "action") {
                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['element'] = 'text';

                                    }
                                }
                                else {
                                    privilegeTableSchema[secKey].Specification.table_body.splice(1, data['Specification']['table_body'].length)
                                    }
                            })
                        })
                    })
                    
                    this.setState((state) => ({ addText: 'User', tableTitle: 'User List', thead: tableHead,privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema)),tableHeadDoctor:tableHeadDoctor }), () => {
                        postService(getUserDetailsById, 'POST', { "data": { "id": rid } }).then(res => {
                            // if (res.status) {
                            //     this.setState((state) => ({ 'loadding': false }));
                            //     this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                            // } 
                            if (res.status) {
                                let pre_link = Storage.get('pre_link');
                                if( pre_link !== undefined && pre_link !== null && pre_link !== '' ){
                                    pre_link = pre_link.slice(1, -1);
                                    this.setState({
                                        'pre_link': pre_link
                                    })
                                    Storage.remove('pre_link');
                                }
                                if (res.data[0]["privileges"].length !== 0) {
                                    privilegeTableSchema.map((data, secKey) => {
                                        data['Specification']['table_body'].map((table_body, table_key) => {
                                            table_body['feilds'].map((feilds, key) => {
                                                if(key===0){
                                                    if (feilds.name === "privilege_name") {
                                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = null
                                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = null
                                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['disable']=true;
                                                    }
                                                    if (feilds.name === "action") {
                                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['element'] = 'text';
    
                                                    }
                                                }
                                                else {
                                                    privilegeTableSchema[secKey].Specification.table_body.splice(1, data['Specification']['table_body'].length)
                                                    }
                                            })
                                        })
                                    })
                                    this.setState({privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema))})

                                    privilegeTableSchema[0]['visible'] = true;
                                    privilegeTableSchema.map((data, secKey) => {
                                        if (secKey === 0) {
                                            data['Specification']['table_body'].map((table_body, table_key) => {
                                            res.data[0]["privileges"].map((privileges, privilege_key) => {
                                                if (privilege_key === 0) {
                                                        table_body['feilds'].map((feilds, key) => {
                                                            if (feilds.name === "privilege_name") {
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = privileges['privilege_id']
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = privileges['privilege_name']
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['disable']=true;
                                                            }
                                                            if (feilds.name === "action") {
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['element'] = 'text';

                                                            }
                                                           
                                                        })
                                                }
                                                else {
                                                    let obj = {
                                                        "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'] ))): [],
                                                       
                                                    }
                                                  
                                                    obj['feilds'].map((feild, key) => {
                                                        if (feild.name === "privilege_name") {
                                                            obj['feilds'][key]['value'] = privileges['privilege_id'];
                                                            obj['feilds'][key]['text'] = privileges['privilege_name'];
                                                            obj['feilds'][key]['disable']=true;
                                                        }
                                                        if (feild.name === "action") {
                                                            obj['feilds'][key]['element'] = 'text';
                                                        }
                                                    })
                                                 data['Specification']['table_body'].push(obj);
                                                }
                                            })
                                        })
                                        }
                                    })
                                    privilegeTableSchema.map((subTable, key) => {
                                            let table_body = subTable.Specification.table_body;
                                            table_body.map((feild, table_key) => {
                                                let row = feild.feilds;
                                                row.map((sub_feild, sub_table_key) => {
                                                    privilegeTableSchema[key].Specification.table_body[table_key].feilds[sub_table_key]["disable"] = true;
                                                    privilegeTableSchema[key].Specification.add_more_title=null;
                                                    privilegeTableSchema[key].Specification.add_more=false;
                                                })
                                            })
                                        })
                                        this.setState({privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema))})
                                }



                                this.setState((state) => ({ 'loadding': false }));
                                this.setState((state) => ({ tbody: res.data[0], loadding: false,tbodyDoctor:res.data[0].mapping_doctor }));

                            }else {
                                this.setState((state) => ({ 'loadding': false }));
                                Modal.error({
                                    title: 'Error message',
                                    content: 'Something went wrong. Please,try again later',
                                    onOk: function () {
                                        window.scrollTo(0, 0);
                                    }
                                });
                            }
                        });
                    });
                    break;

                case 'view-doctor':
                    tableHead = [
                        {
                            "key": 'phone_number',
                            'text': 'Phone'
                        },
                        {
                            "key": 'id',
                            'text': 'Doctor ID'
                        }, {
                            "key": 'departmentname',
                            'text': 'Department/speciality'
                        }, {
                            "key": 'unitname',
                            'text': 'Unit'
                        }, {
                            "key": 'departmentname',
                            'text': 'Department'
                        }, {
                            "key": 'counsellor_name',
                            'text': 'counsellor'
                        }, {
                            "key": 'care_management',
                            'text': 'Care Management'
                        }
                    ]
                    this.setState((state) => ({ addText: 'User', tableTitle: 'User List', thead: tableHead }), () => {
                        postService(getDoctorIdDetails, 'POST', { "ID": rid, "unit_id": unid }).then(res => {
                            console.log(res);
                            if (res.status) {
                                // this.setState((state) => ({ 'loadding': false }));
                                // this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                                const updatedData = res.data.map(item => ({
                                    ...item,
                                    care_management: (item.care_management === '3') ? 'Medical,Surgical' : ((item.care_management === '2')? 'Surgical' : ((item.care_management === '1') ? 'Medical' : '-'  ))
                                }));
                                this.setState((state) => ({ 'loadding': false }));
                                this.setState((state) => ({ tbody: updatedData[0], loadding: false }));
                            } else {
                                this.setState((state) => ({ 'loadding': false }));
                                Modal.error({
                                    title: 'Error message',
                                    content: 'Something went wrong. Please,try again later',
                                    onOk: function () {
                                        window.scrollTo(0, 0);
                                    }
                                });
                            }
                        });
                    });
                    break;
                default:
                    this.setState((state) => ({ 'loadding': false }));
                    break;
            }
        } catch (error) {
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error message',
                content: 'Something went wrong. Please,try again later',
                onOk: function () {
                    window.scrollTo(0, 0);
                }
            });
            console.log(error);
        }
    }
    render() {

        let { slug } = this.props.match.params;
        let { tableTitle, thead, tbody, showEdit,privilegeTableSchema,tableHeadDoctor,tbodyDoctor } = this.state;
        return (
            <Spin spinning={this.state.loadding}>
                <div className="card p-5 m-5">
                    <div className="pb-5">
                        <h1 className="text-heading float-left">{tbody.username || tbody.name}</h1>
                        {(showEdit) &&
                            <a href="#" className="float-right" style={{ 'color': '#455a64' }} onClick={this.editUser.bind(this, tbody)}>Edit <img src={homepage+"/assets/images/icons/edit.png"} /></a>}
                    </div>
                    <div className="row my-auto pb-2">
                        {thead.map((tHdata, tHkey) => {
                            if(tHdata['key'] !== 'counsellor_name'){
                                return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={tHkey}>
                                <p className="data-label">{(tbody[tHdata['key']] && tbody[tHdata['key']] !== null)?tHdata['text']:''}</p>
                                <p className="data-item"> {(tbody[tHdata['key']] && tbody[tHdata['key']] !== null) ? ': '+ tbody[tHdata['key']] : ''}</p>
                            </div>)
                            }                           
                        })}
                    </div>
                    <div className={tbody['counsellors']&&tbody['counsellors'].length>0?"row my-auto pb-5":"row my-auto"}>
                    {(tbody&&tbody['counsellors'] && tbody['counsellors'].length>0 && Array.isArray(tbody['counsellors'])) &&
                                <React.Fragment>
                                    <div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                 <p className="data-label mb-1">counsellor:</p>
                                 </div> 
                                 {(tbody['counsellors']).map((counsellors, key) => {
                                    return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={key}>
                                        <p className="data-item">{counsellors['counsellor_name']}</p>
                                    </div>)
                                })}
                                </React.Fragment>
                                }
                    </div>
                    <div className={tbody['mapping_unit']&&tbody['mapping_unit'].length>0?"row my-auto pb-5":"row my-auto"}>
                        {(tbody&&tbody['mapping_unit'] &&tbody['mapping_unit'].length>0 && Array.isArray(tbody['mapping_unit'])) &&
                            <React.Fragment>
                                <div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                    <p className="data-label mb-1">Mapping Unit:</p>
                                </div>
                                {(tbody['mapping_unit']).map((mapping_units, key) => {
                                    return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={key}>
                                        <p className="data-item">{mapping_units['unitname']}</p>
                                    </div>)
                                })}
                            </React.Fragment>
                        }

                    </div>
                    <div className={tbody['counsellor_types']&&tbody['counsellor_types'].length>0?"row my-auto pb-5":"row my-auto"}>
                        {(tbody&&tbody['counsellor_types']&& tbody['counsellor_types'].length>0 && Array.isArray(tbody['counsellor_types'])) &&
                            <React.Fragment>
                                <div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                    <p className="data-label mb-1">Counsellor Type:</p>
                                </div>
                                {(tbody['counsellor_types']).map((previlage, key) => {
                                    return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={key}>
                                        <p className="data-item">{previlage['text']}</p>
                                    </div>)
                                })}
                            </React.Fragment>
                        }


                    </div>
                    <div className={tbody['counselling_stations']&&tbody['counselling_stations'].length>0?"row my-auto pb-5 ":"row my-auto"}>
                        {(tbody&&tbody['counselling_stations']&& tbody['counselling_stations'].length>0 && Array.isArray(tbody['counselling_stations'])) &&
                            <React.Fragment>
                                <div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                    <p className="data-label mb-1">Mapped Counselling Stations:</p>
                                </div>
                                {(tbody['counselling_stations']).map((item, key) => {
                                    return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={key}>
                                        <p className="data-item">{item['name']}</p>
                                    </div>)
                                })}
                            </React.Fragment>
                        }


                    </div>
                    <div className={tbody['mapping_doctor_secrect']&&tbody['mapping_doctor_secrect'].length>0?"row my-auto pb-5 ":"row my-auto"}>
                        {(tbody&&tbody['mapping_doctor_secrect']&& tbody['mapping_doctor_secrect'].length>0 && Array.isArray(tbody['mapping_doctor_secrect'])) &&
                            <React.Fragment>
                                <div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                    <p className="data-label mb-1">Mapped Doctors:</p>
                                </div>
                                {(tbody['mapping_doctor_secrect']).map((item, key) => {
                                    return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex" key={key}>
                                        <p className="data-item">{item['name']}</p>
                                    </div>)
                                })}
                            </React.Fragment>
                        }


                    </div>
                    {tbodyDoctor.length>0&&(<div className='row pt-3 pl-3 pr-3'>
                            <h4 class=" w-100 doctormaping">Doctors</h4>
                             <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    <tr>
                                        {tableHeadDoctor.map((head, key) => {
                                            return (<td className="text-capitalize" key={key}>{head['text']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                {tbodyDoctor&& tbodyDoctor.map((body, key) => {
                                        return (<tr key={key}>

                                            {tableHeadDoctor.map((head, Hkey) => {
                                                if (head['key'] === 's_no') {
                                                    return (<td>{key + 1}</td>)
                                                }
                                                return (
                                                    <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : '--'}</td>
                                                )

                                            })
                                            }

                                        </tr>)
                                    })}
                                
                                {(tbodyDoctor && tbodyDoctor.length === 0) && <React.Fragment>
                                    <tr>
                                       <td colSpan={tableHeadDoctor.length+1} className="text-center">
                                          <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                          <p className="no-data mb-0">No Data</p>
                                       </td>
                                      </tr> 
                                                    </React.Fragment>}  
                                </tbody>
                            </table>
                        </div>
                        </div>)}
                    <div className="row my-auto pb-5 pt-3 pl-3 pr-3">
                        {privilegeTableSchema.map((feild, key) => {
                            if (feild.visible) {
                            return (<React.Fragment key={key}>
                                <div className="d-inline-flex w-100">
                                    <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                </div>
                                <div className="financial-table table-responsive">
                                    <Tableantd {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} />
                                </div>
                            </React.Fragment>)
                            }
                        })}

                    </div>

                   
                    <div className="row justify-content-center">

                        <button className="btn btn-success btn-next text-capitalize" onClick={this.cancel.bind(this)}>cancel</button>
                    </div>
                </div>
            </Spin>

        )

    }
}
export default User_Details;